// import { Link } from "@/components/shared/link";
// import { ArrowLeft } from "@/components/shared/icons";
import { View } from "@/components/ui";
import { ClientVoucherContainer } from "@/containers/profile/my-vouchers/client-voucher";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

export const MyVouchers = () => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  return (
    <View className="flex flex-1 flex-col">
      <View className="static flex flex-1 flex-row items-center justify-between border-b pb-0 md:pb-4">
        <View className="flex flex-row items-center gap-2 p-4 md:p-0">
          {/* CONSISTENECY PROBLEM <Link href="/profile/overview">
            <ArrowLeft className="size-5" />
          </Link> */}
          <IconButton
            variant={isMobile ? "ghost" : "secondary"}
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-0 md:px-3 md:py-2"
            onClick={() => push({ pageKey: "overview" })}
          />
          <Typography variant="label-lg" color="foreground-default">
            Vouchers
          </Typography>
        </View>
      </View>

      <ClientVoucherContainer />
    </View>
  );
};
